import { useContext } from "react";
import { HttpMethods } from "../../enums/HttpMethods";
import { NotificationTypes } from "../../enums/NotificationTypes";
import VspPortalContext from "../../store/VspPortalContext";
import { SpokeStatusDto } from "./SpokeStatusDto";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";



export const useSpoke = (): [

    ( villageCode: string ) => Promise<SpokeStatusDto | null>,

] => {

    const { fetchData, getHttpOptions } = useVspPortalHttp( );
    const { dispatch, state } = useContext( VspPortalContext );
    

    const getSpokeStatus = async( villageCode: string ): Promise<SpokeStatusDto | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );
        const query = `${process.env.REACT_APP_API_URL}/spoke/status?villageCode=${villageCode}`;
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching Spoke status' });

            return null;

        }

        return await response.response?.json( );
        
    };


    return [ getSpokeStatus ];
    

};
